import { businessUnit } from '@/utils/themes/theme'

export const getTierLabel = (tier) => {
  if (businessUnit(globalThis?.location?.hostname) === 'VDBOT') {
    return (
      {
        0: 'Bronze',
        1: 'Prata',
        2: 'Ouro',
        3: 'Platina',
        4: 'Rubi',
        5: 'Esmeralda',
        6: 'Diamante'
      }[tier] || '-'
    )
  }
  return { 0: 'Nível 1', 1: 'Nível 2' }[tier] || '-'
}
